import ManageSubscriptions from './ManageSubscriptions';

export default ManageSubscriptions;
